import { FormControlLabel } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import PropTypes from 'prop-types';
import React from 'react';
import Radio from './index';

const useStyles = makeStyles((theme) => ({
  root: {
    margin: 0,
  },

  disabled: {},

  label: {
    marginLeft: 8,
    fontSize: theme.typography.pxToRem(14),
    fontWeight: 'normal',
    fontStretch: 'normal',
    fontStyle: 'normal',
    lineHeight: 1.71,
    letterSpacing: 'normal',
    color: theme.colors.dark,

    '&$disabled': { color: theme.colors.grey99 },
  },
}));

function FormControlRadio(props) {
  // eslint-disable-next-line react/prop-types
  const { classes, RadioProps, disabledSelect, ...otherProps } = props;
  const styles = useStyles();

  return (
    <FormControlLabel
      {...otherProps}
      classes={{
        root: `${styles.root} ${classes.root}`,
        disabled: `${styles.disabled} ${classes.disabled}`,
        label: `${styles.label} ${classes.label}`,
      }}
      control={<Radio {...RadioProps} />}
    />
  );
}

FormControlRadio.propTypes = {
  classes: PropTypes.objectOf(PropTypes.string),
  // Props applied to Radio
  RadioProps: PropTypes.object,
};

FormControlRadio.defaultProps = {
  classes: {},
  RadioProps: {},
};

export default FormControlRadio;
